import { makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles(
  (theme) => ({
    root: {
      display: 'flex',
      columnGap: theme.spacing(0.5),
      margin: theme.spacing(1, 0, 2),
    },
  }),
  { name: 'Filters' }
);
